import { Observable, merge, take, tap, finalize } from 'rxjs';
import {
  TCompanyConfigs,
  companyConfigService,
} from '../../../../shared/services/companyConfig/companyConfig.service.ts';
import { Pub, State, Sub } from '../../../../shared/state/state.abstract.ts';

class PubImpl extends Pub<IEmailTabState> {
  recordData(dataToSave: IEmailTabState['dataToSave']) {
    this.emit('recordData', { dataToSave });
  }
  saveData() {
    this.emit('saveData', {});
  }
  clearStream() {
    this.emit(undefined, {});
  }
}
class SubImpl extends Sub<IEmailTabState> {
  protected actionHandlers(): Observable<IEmailTabState> {
    return merge(this.saveData());
  }

  private saveData(): Observable<IEmailTabState> {
    return this.actionListener('saveData').pipe(
      tap(({ dataToSave }) => {
        companyConfigService.saveConfigData(dataToSave).pipe(take(1)).subscribe();
      }),
      finalize(() => emailTabState.pub.clearStream()),
    );
  }
}

class EmailTabState extends State<IEmailTabState> {
  pub = new PubImpl(this.stream$);
  sub = new SubImpl(this.stream$);
}

export const emailTabState = new EmailTabState({
  action: undefined,
  dataToSave: {},
});

export interface IEmailTabState {
  action: undefined | 'recordData' | 'saveData';
  dataToSave: Partial<TCompanyConfigs>;
}
